import type { EditingProject } from "../types/project";
import { formatFrames } from "../core/time";

type Props = {
  resume: { project: EditingProject; file: File } | null;
  busy: boolean;
  error: string | null;
  onImport: (files: FileList) => void;
  onResume: () => void;
  onDiagnostics: () => void;
};

export function HomeScreen({
  resume,
  busy,
  error,
  onImport,
  onResume,
  onDiagnostics,
}: Props) {
  return (
    <main className="home shell">
      <header className="brand">
        <div className="brand__mark" aria-hidden="true">
          <span />
          <span />
          <span />
          <span />
          <span />
        </div>
        <div>
          <p className="eyebrow">LOCAL AUDIO TRIMMER</p>
          <h1>VoiceCutter</h1>
          <p>数時間の録音から、必要な数分を正確に。</p>
        </div>
      </header>

      {error && (
        <div className="error-banner" role="alert">
          {error}
        </div>
      )}

      {resume && (
        <button
          type="button"
          className="resume-card"
          onClick={onResume}
          data-testid="home.resume"
        >
          <span className="resume-card__label">編集を続ける</span>
          <strong title={resume.project.fileName}>
            {resume.project.fileName}
          </strong>
          <span className="resume-card__times">
            {formatFrames(resume.project.startFrame, resume.project.sampleRate)}{" "}
            → {formatFrames(resume.project.endFrame, resume.project.sampleRate)}
          </span>
          <span className="resume-card__action">
            開く <span aria-hidden="true">›</span>
          </span>
        </button>
      )}

      <section className="home__actions" aria-label="音声の読み込み">
        <label className={`primary-file-button ${busy ? "is-busy" : ""}`}>
          <input
            type="file"
            accept="audio/*,.m4a,.aac,.mp3,.wav"
            multiple
            disabled={busy}
            data-testid="home.import"
            onChange={(event) =>
              event.currentTarget.files && onImport(event.currentTarget.files)
            }
          />
          <span aria-hidden="true">＋</span>
          {busy ? "音声を確認中…" : resume ? "新しい音声を選択" : "音声を選択"}
        </label>
        <p>FilesからM4A / AAC / MP3 / WAVを選択</p>
        <p className="privacy-note">音声はこの端末から外へ送信されません</p>
      </section>

      <footer className="home__footer">
        <button type="button" className="text-button" onClick={onDiagnostics}>
          動作環境を確認
        </button>
      </footer>
    </main>
  );
}
